<template>
  <div style="padding:15px;" class="containerTable">
    <vxe-toolbar id="toolbarId_paidRecord" :custom="{storage: true}" export :refresh="{query: RefreshList}">
      <template v-slot:buttons>
        <el-button v-if="getLimit('Account_search_button')" @click="funcFilter">查询</el-button>
        <el-button v-if="getLimit('Account_export_button')" @click="funcExport">导出</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="type" title="接口类型" min-width="160" sortable>
          <template v-slot="{row}">{{ type[row.type] }}</template>
        </vxe-table-column>
        <template v-slot:header>
          <el-select v-model="listQuery.type" clearable placeholder="请选择接口类型">
            <el-option v-for="(v,k) in type" :key="k" :label="v" :value="k" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="totalFee" title="总充值金额" min-width="120" sortable />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="surplusFee" title="余额" min-width="100" sortable />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column min-width="240" field="gmtCreated" title="创建时间" sortable />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            class="unite-data"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="description" title="描述" min-width="160" sortable />
        <template v-slot:header>
          <el-input v-model="listQuery.description" placeholder="请输入描述" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-tooltip v-if="getLimit('Account_charget_button')" class="item" effect="dark" content="充值记录" placement="top">
            <vxe-button type="text" @click="funcCharget(scope.row.type)">
              <em class="el-icon-notebook-2" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip v-if="getLimit('Account_consume_button')" class="item" effect="dark" content="消费记录" placement="top">
            <vxe-button type="text" @click="funcConsume(scope.row.type)">
              <em class="el-icon-shopping-cart-full" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <vxe-modal v-model="modelChargetFlag" title="充值记录" width="1200" height="80%" resize>
      <charget ref="chargetRef" /> 
    </vxe-modal>
    <vxe-modal v-model="modelConsumeFlag" title="消费记录" width="1200" height="80%" resize>
      <consume ref="consumeRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from '@/utils/request'
import charget from './chargetLog' 
import consume from './consumeLog'
export default {
  name: 'SMSManageList',
  components: {
    charget,
    consume
  },
  data() {
    return {
      modelChargetFlag: false,
      modelConsumeFlag: false,
      loading: false,
      tableData: [],
      exportObj:{
        exportUrl:"/ntocc-basic-api/paidRecord/exportPaidRecord",//导出接口
        name:'消费记录'
        },
      listQuery: {
        gmtCreatedRange:[],
        type: '',
        description: '',
        gmtCreatedStart: '',
        gmtCreatedEnd: '',
        pageNum: 1,
        pageSize: 20,
        sortField: '',
        sortType: '',
        total: 0
      },
      dict:[],
      type:[]
    }
  },
  created() {
    this.getDataDict()
    this.findList()
  },
  methods: {
    getDataDict() {
      return new Promise((resolve) => {
        request({
          url: '/ntocc-basic-api/paidRecord/getDataDict',
          method: 'get',
          params: { types: 'typeInterface,typeThird,interf,typeCharge' }
        }).then((response) => {
          if (response.status == 0 && response.data) {
            const records = response.data.records
            if (records) {
              let type = {},
                typeThird = {},
                typeCharge = {},
                interf = {}
              for (const i in records) {
                let dict = records[i]
                if (dict.type == 'typeInterface') {
                  type[dict.code] = dict.name
                } else if (dict.type == 'typeThird') {
                  typeThird[dict.code] = dict.name
                } else if (dict.type == 'typeCharge') {
                  typeCharge[dict.code] = dict.name
                } else if (dict.type == 'interf') {
                  if(dict.remark){
                    if(!interf[dict.remark]){
                      interf[dict.remark] = []
                    }
                    interf[dict.remark][dict.code] = dict.name
                  }
                }
              }
              this.$set(this, 'type', type)
              this.dict.typeThird = typeThird
              this.dict.typeCharge = typeCharge
              this.dict.interf = interf
            }
          }
        })
      })
    },
    // 列表
    findList() {
      this.loading = true
      return new Promise((resolve) => {
        request({
          url: '/ntocc-basic-api/paidRecord/customerAccount',
          method: 'get',
          params: this.listQuery
        }).then((response) => {
          //console.log(response);
          this.tableData = response.data.records
         
          this.listQuery.total = response.data.total
          this.loading = false
          resolve()
        })
      })
    },
    // 充值记录
    funcCharget(code) {
      this.$refs.chargetRef.init(code)
      this.modelChargetFlag = true
    },
    // 消费记录
    funcConsume(code) {
      this.$refs.consumeRef.init(code, this.dict)
      this.modelConsumeFlag = true
    },
  }
}
</script>